(function () {
  var MQ = '(min-width: 750px)';

  function isDesktop() {
    return window.matchMedia(MQ).matches;
  }

  function setOpen(card, open) {
    card.classList.toggle('is-open', open);
    var btn = card.querySelector('.hm-ct__toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function onToggle(event) {
    if (isDesktop()) return;
    var btn = event.currentTarget;
    var card = btn.closest('[data-hm-ct-card]');
    var root = btn.closest('[data-hm-contactos]');
    if (!card || !root) return;
    var open = !card.classList.contains('is-open');
    if (root.getAttribute('data-hm-one') === 'true' && open) {
      root.querySelectorAll('[data-hm-ct-card]').forEach(function (other) {
        if (other !== card) setOpen(other, false);
      });
    }
    setOpen(card, open);
  }

  function bind(root) {
    if (!root || root.dataset.hmCtBound === '1') return;
    root.dataset.hmCtBound = '1';
    root.querySelectorAll('.hm-ct__toggle').forEach(function (btn) {
      btn.addEventListener('click', onToggle);
    });
    if (!isDesktop() && root.getAttribute('data-hm-first') === 'true') {
      var first = root.querySelector('[data-hm-ct-card]');
      if (first) setOpen(first, true);
    }
  }

  function init(root) {
    if (root) {
      delete root.dataset.hmCtBound;
      bind(root);
      return;
    }
    document.querySelectorAll('[data-hm-contactos]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hm-contactos]');
    if (root) init(root);
  });
})();
